export const SUGGESTED = 'suggested';
export const LOCATIONS = 'locations';
export const ERROR = 'error';
export const AS_ENTERED = 'As entered';
export const HELPER_TEXT = 'helper-text';
